import { useCallback, useMemo } from "react";
import type { ReactElement } from "react";

import SavedSearchWebhookTableForm from "../components/SavedSearchWebhookTableForm/SavedSearchWebhookTableForm";
import type { IDynamicListOption } from "../types/webhook";
import { useTestSavedSearchWebhookMutation } from "../query/mutations/useTestSavedSearchWebhookMutation";
import useGetAccountSearches from "../query/queries/useGetAccountSearches";
import useGetSavedSearchWebhooks from "../query/queries/useGetSavedSearchWebhooks";

const SavedSearchWebhooksContainer = (): ReactElement | null => {
    const { data: webhooks } = useGetSavedSearchWebhooks();
    const { mutate: testWebhook } = useTestSavedSearchWebhookMutation();
    const { data: accountSearches } = useGetAccountSearches();

    const dynamicLists: IDynamicListOption[] = useMemo(
        () =>
            (accountSearches ?? []).map((s) => ({
                id: s.searchId,
                name: s.name,
                totalCount: s.totalNumberOfResults,
                ownerUserName: s.ownerUserName,
            })),
        [accountSearches],
    );

    const handleTest = useCallback(
        (url: string) => {
            testWebhook({ url });
        },
        [testWebhook],
    );

    if (!webhooks || !accountSearches) {
        return null;
    }

    return (
        <SavedSearchWebhookTableForm
            webhooks={webhooks}
            dynamicLists={dynamicLists}
            onTest={handleTest}
        />
    );
};

export default SavedSearchWebhooksContainer;
